export const serviceConstants = {
    HOST_NAME: process.env.REACT_APP_HOST_NAME,
    API_HOST_NAME: process.env.REACT_APP_API_HOST_NAME,
    SOCKET_HOST_NAME: process.env.REACT_APP_SOCKET_HOST_NAME,
    SYSTEM_TIME_ZONE: process.env.REACT_APP_SYSTEM_TIMEZONE || 'America/New_York',
    STRIPE_API_PUBLIC_KEY: process.env.REACT_APP_STRIPE_API_PUBLIC_KEY,
    AG_GRID_LICENSE_KEY: process.env.REACT_APP_AG_GRID_LICENSE_KEY,
    VERSION: '1.0'
};

export const templateIds = {
    htmlEmailWithLogo: 'd-37463a895a614d65a0f425fa31c1e79c'
};

export const auditEnums = {
    IDENTIFIERS: {
        PatientRecord: 'Patient_Record',
        PatientInsuranceRecord: 'Patient_Insurance_Record',
        OrderRecord: 'Order_Record',
        UserRecord: 'User_Record',
        CompanyRecord: 'Company_Record',
        FacilityRecord: 'Facility_Record',
        PhysicianRecord: 'Physician_Record',
        ReportRecord: 'Report_Record',
        RequistionRecord: 'Requistion_Record',
        InvoiceRecord: 'Invoice_Record',
        LabInventoryRecord: 'Lab_Inventory_Record',
        InstrumentRecord: 'Instrument_Record',
        LabRecord: 'Lab_Record',
        AnalyteRecord: 'Analyte_Record',
        QcRangeRecord: 'QC_Range_Record',
        QcSampleRecord: 'QC_Sample_Record',
        QcResultRecord: 'QC_Result_Record',
        DiagnosisCodeRecord: 'Diagnosis_Code_Record',
        MedicationRecord: 'Medication_Record',
        MaintenanceEventRecord: 'Maintenance_Event_Record',
        MaintenanceSlotRecord: 'Maintenance_Slot_Record',
        InsuranceProviderRecord: 'Insurance_Provider_Record',
        KitRecord: 'Kit_Record',
        ExportRecord: 'Export_Record',
        ImportRecord: 'Import_Record',
        FlagRecord: 'Flag_Record',
        ReflexRuleRecord: 'Reflex_Rule_Record',
        PatientMedicationRecord: 'Patient_Medication_Record'
    },
    EVENTTYPES: {
        PatientLogIn: 'Patient_LoggedIn',
        PatientLogOut: 'Patient_LogOut',
        PatientVerificationPass: 'Patient_Verification_Passed',
        PatientSetUsernamePassword: 'Patient_Set_Username_Password',
        PatientUpdatePassword: 'Patient_Update_Password',
        OrderResultViewed: 'Order_Result_Viewed',
        OrderResultDownloaded: 'Order_Result_Downloaded',
        OrderGridExported: 'Order_Grid_Exported',
        RequisitionGridExported: 'Requisition_Grid_Exported',
        PatientGridExported: 'Patient_Grid_Exported',
        PatientInsuranceGridExported: 'Patient_Insurance_Grid_Exported',
        PatientDuplicateGridExported: 'Patient_Duplicate_Grid_Exported',
        InvoiceGridExported: 'Invoice_Grid_Exported',
        SelfPaymentGridExported: 'Self_Payment_Grid_Exported',
        AuditGridExported: 'Audit_Grid_Exported',
        BrooksLIMSRecordGridExported: 'Brooks_LIMS_Record_Grid_Exported',
        StateReportGridExported: 'State_Report_Grid_Exported',
        EndOfDayReportGridExported: 'EndOfDay_Report_Grid_Exported',
        FailedSMSEmailReportGridExported: 'FailedSMSEmail_Report_Grid_Exported',
        OrderTotalGridExported: 'Order_Total_Grid_Exported',
        CompanyGridExported: 'Company_Grid_Exported',
        FacilityGridExported: 'Facility_Grid_Exported',
        LocationGridExported: 'Location_Grid_Exported',
        PhysicianGridExported: 'Physician_Grid_Exported',
        UserGridExported: 'User_Grid_Exported',
        FacilityPatientTestResultManagementGridExported: 'Facility_Patient_Test_Result_Management_Grid_Exported',
        FacilityInventoryGridExported: 'FacilityInventory_Grid_Exported',
        AnalyteGridExported: 'Analyte_Grid_Exported',
        QcRangeGridExported: 'QC_Range_Grid_Exported',
        QcSampleGridExported: 'QC_Sample_Grid_Exported',
        LabGridExported: 'Lab_Grid_Exported',
        LabInventoryGridExported: 'LabInventory_Grid_Exported',
        InstrumentGridExported: 'Instrument_Grid_Exported',
        LabInventoryTrackingHistoryGridExported: 'LabInventory_Tracking_History_Grid_Exported',
        DeliveryPickupOrderGridExported: 'DeliveryPickupOrder_Grid_Exported',
        DriverShiftInformationGridExported: 'DriverShift_Information_Grid_Exported',
        DriverGridExported: 'Driver_Grid_Exported',
        NotificationTypeGridExported: 'NotificationType_Grid_Exported',
        FacilityNotificationManagementGridExported: 'FacilityNotification_Management_Grid_Exported',
        UserInfoManagementGridExported: 'UserInfo_Management_Grid_Exported',
        LIMSResultImportGridExported: 'LIMS_ResultImport_Grid_Exported',
        InsuranceProviderGridExported: 'Insurance_Provider_Grid_Exported',
        MaintenanceGridExported: 'Maintenance_Grid_Exported',
        SelfPaymentGridDocumentImported: 'Self_Payment_Grid_Document_Imported',
        FlagCreated: 'Flag_Created',
        FlagUpdated: 'Flag_Updated',
        FlagDeleted: 'Flag_Deleted',
        FlagGridExported: 'Flag_Grid_Exported',
        ReflexRuleCreated: 'Reflex_Rule_Created',
        ReflexRuleUpdated: 'Reflex_Rule_Updated',
        ReflexRuleDeleted: 'Reflex_Rule_Deleted',
        ReflexRuleGridExported: 'Reflex_Rule_Grid_Exported',
        PatientMedicationCreated: 'Patient_Medication_Created',
        PatientMedicationUpdated: 'Patient_Medication_Updated',
        PatientMedicationDeleted: 'Patient_Medication_Deleted',
        PatientMedicationGridExported: 'Patient_Medication_Grid_Exported',
        UserLoggedIn: 'User_LoggedIn',
        UserLoggedOut: 'User_LoggedOut',
        QcResultGridExported: 'QC_Result_Grid_Exported',
        PatientPaymentGridExported: 'Patient_Payment_Grid_Exported',
        ResultImportProcessed: 'Result_Import_Processed',
        ResultImportGridExported: 'Result_Import_Grid_Exported'
    }
};

export const patientImagePath = '/files/patient/images/';

export const CropImgMaxWidth = 600;

export const colorValue = {
    slate: '#64748b',
    gray: '#6b7280',
    zinc: '#71717a',
    neutral: '#737373',
    stone: '#78716c',
    red: '#ef4444',
    orange: '#f97316',
    amber: '#f59e0b',
    yellow: '#eab308',
    lime: '#84cc16',
    green: '#22c55e',
    emerald: '#10b981',
    teal: '#14b8a6',
    cyan: '#06b6d4',
    sky: '#0ea5e9',
    blue: '#3b82f6',
    indigo: '#6366f1',
    violet: '#8b5cf6',
    purple: '#a855f7',
    fuchsia: '#d946ef',
    pink: '#ec4899',
    rose: '#f43f5e'
};

export const notificationTemplateValues = [
    {
        name: 'patient_first_name',
        label: 'Patient First Name'
    },
    {
        name: 'patient_last_name',
        label: 'Patient Last Name'
    },
    {
        name: 'patient_full_name',
        label: 'Patient Full Name'
    },
    {
        name: 'test_name',
        label: 'Test Name'
    },
    {
        name: 'facility_name',
        label: 'Facility Name'
    },
    {
        name: 'sample_id',
        label: 'Sample ID'
    },
    {
        name: 'requisition_number',
        label: 'Requisition Number'
    },
    {
        name: 'collected_time',
        label: 'Collected Time'
    },
    {
        name: 'lims_url',
        label: 'LIMS URL'
    },
    {
        name: 'patient_portal_url',
        label: 'Patient Portal URL'
    }
];

export const systemFields = [
    {
        name: 'none',
        title: 'None',
        category: ''
    },
    {
        name: 'sample',
        title: 'Sample ID',
        category: 'test_info'
    },
    {
        name: 'sampleType',
        title: 'Sample Type',
        category: 'test_info'
    },
    {
        name: 'collected',
        title: 'Collection Date',
        category: 'test_info'
    },
    {
        name: 'analyteName',
        title: 'Analyte Name',
        category: 'results'
    },
    {
        name: 'analyteResult',
        title: 'Analyte Result',
        category: 'results'
    },
    {
        name: 'analyteUnits',
        title: 'Analyte Units',
        category: 'results'
    },
    {
        name: 'analyteArea',
        title: 'Analyte Area',
        category: 'results'
    }
];

export const ALL_CONTROL_TYPES_ID = 'allControlTypes';
export const ALL_CONTROL_TYPES_LABEL = 'All Types';

export const ALL_LOT_NUMBERS_ID = 'allLotNumbers';
export const ALL_LOT_NUMBERS_LABEL = 'All Active Lots';

export const ALL_SAMPLES_ID = 'allSamples';
export const ALL_SAMPLES_LABEL = 'All Samples';

export const ALL_INSTRUMENTS_ID = 'allInstruments';
export const ALL_INSTRUMENTS_LABEL = 'All Instruments';
